import { render } from "./InfiniteList.vue?vue&type=template&id=5ff71031&scoped=true&ts=true"
import script from "./InfiniteList.vue?vue&type=script&lang=ts"
export * from "./InfiniteList.vue?vue&type=script&lang=ts"

import "./InfiniteList.vue?vue&type=style&index=0&id=5ff71031&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff71031"]])

export default __exports__